import { Grid } from '@progress/kendo-react-grid';
import { RefObject, useMemo } from 'react';
import { GridColumn } from 'src/components/GridWrapper';
import OfflineSupplierCell from 'src/sections/enter_receipt/custom_grid_cell/cells/OfflineSupplierCell';

export const useOfflineSupplierColumns: (tableRef: RefObject<Grid>) => GridColumn<any>[] = () => {
  const columns: GridColumn<any>[] = useMemo(
    () => [
      {
        field: 'supplierCompanyName',
        title: 'Name',
        filter: 'text',
        dataType: 'string',
        component: OfflineSupplierCell,
      },
      {
        field: 'apId',
        title: 'AP ID',
        filter: 'text',
        dataType: 'string',
        component: OfflineSupplierCell,
      },
      {
        field: 'accountNumber',
        title: 'Customer #',
        filter: 'text',
        dataType: 'string',
        component: OfflineSupplierCell,
      },
      {
        field: 'addressLine1',
        title: 'Address',
        filter: 'text',
        dataType: 'string',
        component: OfflineSupplierCell,
      },
      {
        field: 'createdBy',
        title: 'Created By',
        filter: 'text',
        dataType: 'string',
        component: OfflineSupplierCell,
      },
    ],
    []
  );
  return columns;
};

export default useOfflineSupplierColumns;
